import { Checkbox, TableCell, TableRow } from "@mui/material";
import { type Ref, forwardRef } from "react";
import type { ItemProps } from "react-virtuoso";
import { useTableVirtualizedSelectContext } from "../context";

export const VirtuosoTableRow = forwardRef(function VirtuosoTable<Data extends { _id: string }>(
  { children, item, ...props }: ItemProps<Data>,
  ref: Ref<HTMLTableRowElement>
) {
  const { isChecked, toggleCheckbox, TableRowProps, hiddenCheckbox } = useTableVirtualizedSelectContext();

  return (
    <TableRow {...props} {...TableRowProps} ref={ref}>
      {!hiddenCheckbox && (
        <TableCell>
          <Checkbox sx={{ p: 0 }} checked={isChecked(item)} onChange={() => toggleCheckbox(item)} />
        </TableCell>
      )}
      {children}
    </TableRow>
  );
});
